import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=4875638d&scoped=true&"
import script from "./DataTableRow.vue?vue&type=script&lang=js&"
export * from "./DataTableRow.vue?vue&type=script&lang=js&"
import style0 from "./DataTableRow.vue?vue&type=style&index=0&id=4875638d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875638d",
  null
  
)

export default component.exports